<template>
  <b-modal
    :hide-footer="true"
    centered
    :no-close-on-backdrop="true"
    size="md"
    :id="'status-historico-' + model"
    @hidden="resetModal"
    title=""
  >
    <!--  -->
    <template #modal-header="{ close }" v-if="!loadingMotivos">
      <h5 v-html="title"></h5>
      <button
        type="button"
        aria-label="Close"
        class="close text-danger"
        @click="close()"
      >
        ×
      </button>
    </template>
    <load
      v-if="loadingMotivos || loading"
      mode="table"
      message="Aguarde um momento."
    />
    <form v-else @submit.prevent="submit">
      <div class="row">
        <form-select
          v-if="substatus.length > 0"
          label="Motivo"
          :itens="substatus"
          v-model="motivo"
          :required="true"
          :loading="loadingMotivos"
        />
        <form-textarea
          v-if="isNotMotivoValido(this.motivo) || this.statusAtual == 20"
          v-model="observacoes"
          label="Descreva o motivo da atualização"
          :required="true"
        />
        <form-calendar
          :max-date="dataNow"
          v-model="data"
          label="Data da Ação"
          :required="true"
        />
      </div>
      <div class="pt-4 d-flex justify-content-end">
        <button class="btn btn-success btn-sm mx-0" type="submit">
          <i class="mdi mdi-content-save"></i>
          Salvar
        </button>
      </div>
    </form>
  </b-modal>
</template>
<script>
  export default {
    props: [
      "titulo_modulo",
      "model",
      "modulo",
      "statusAnterior",
      "statusAtual",
      "id",
      "status",
      "multiplo",
    ],
    data() {
      return {
        dataNow: moment().format("YYYY/MM/DD"),
        motivo: "",
        observacoes: "",
        data: "",
        substatus: [],
        status_pai: null,
        loadingMotivos: true,
        loading: false,
        title: "",
        motivosNaoValidos: [14, 24, 29, 37, 127],
      };
    },
    watch: {
      statusAtual: function (val) {
        this.motivo = null;
        this.status_pai = val;
        this.getSubStatus(this.status_pai);
        this.title = `Voce está atualizando o status do <b>${
          this.titulo_modulo
        }</b><br>
                  De <b class="badge" style="background:${this.getStatusCor(
                    this.statusAnterior
                  )};color:white">${this.getStatusTitulo(
          this.statusAnterior
        )}</b> para
                  <b class="badge"style="background:${this.getStatusCor(
                    this.statusAtual
                  )};color:white">${this.getStatusTitulo(this.statusAtual)}</b>`;
      },
    },
    mounted() {},
    methods: {
      getStatusTitulo(id) {
        if (this.status.length != undefined) {
          const result = this.status.filter((item) => item.id == id);
          //console.log(result);
          return result[0]
            ? result[0].descricao
              ? result[0].descricao
              : result[0].value
            : "";
        }
        this.status_id = id;
      },
      getStatusCor(id) {
        if (this.status.length != undefined) {
          const result = this.status.filter((item) => item.id == id);
          //console.log(result);
          return result[0]
            ? result[0].descricao
              ? result[0].cor
              : result[0].value
            : "";
        }
        this.status_id = id;
      },
      getSubStatus(status) {
        this.loadingMotivos = true;
        axios
          .post(`api/dashboard/admin/getSubStatus`, {
            status_pai: status,
            module: this.modulo,
            model: this.model,
          })
          .then((response) => {
            this.substatus = response.data;
            this.loadingMotivos = false;
          });
      },
      isNotMotivoValido(numero) {
        return this.motivosNaoValidos.includes(Number(numero));
      },
      submit() {
        // this.data = moment(this.data, "YYYY-MM-DD").format("DD/MM/YYYY");
        this.loading = true;
        axios
          .post("api/dashboard/status/historico", {
            id: this.id,
            multiplo: this.multiplo ? this.multiplo : false,
            motivo: this.motivo,
            observacoes: this.observacoes,
            status_anterior: this.statusAnterior,
            status_atual: this.statusAtual,
            data: this.data,
            module: this.modulo,
            model: this.model,
          })
          .then((response) => {
            this.$emit("submit", "historico");
            this.$emit("historico");
            this.$snack.success({
              button: false,
              text: "Histórico salvo com sucesso.",
            });
            this.load = false;
            this.loading = false;
          })
          .finally(() => {
            this.motivo = "";
            this.observacoes = "";
            this.data = "";

            this.$bvModal.hide("status-historico-" + this.model);
          });
      },
      resetModal() {
        this.$emit("reload");
      },
    },
  };
</script>
